
import { useContext, useState } from "react";
import CalendarsContext from "../../../context/NewCalendarContext/CalendarsContext";
import { cleardeleteNonWorkingDayModal } from "../../../context/NewCalendarContext/Actions";
import { Button, Dialog, DialogContent, TextField } from "@material-ui/core"
import styles from '../Calendars.module.css'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "@apollo/client";
import {
    GET_NON_WORKING, DELETE_NON_WORKING,
    GET_NON_WORKING_BY_DATE,
    GET_COUNT_EVENT_NONWORKINGDAY,
    GET_NON_WORKING_BY_MONTH_YEAR
} from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import moment from "moment";


const DeleteNonWorkingDay = ({ calendarDate, date }: any) => {
    const { state, dispatch } = useContext(CalendarsContext)
    const [activo, setactivo] = useState(false)
    const [deleteCalendars] = useMutation(DELETE_NON_WORKING, {
        refetchQueries: [
            { query: GET_NON_WORKING_BY_DATE, variables: { calendarId: parseInt(state._id), initDate: moment(date) } },
            {
                query: GET_NON_WORKING_BY_MONTH_YEAR, variables: {
                    calendarId: parseInt(state._id),
                    month: parseInt(moment(date).format('M')),
                    year: parseInt(moment(date).format('YYYY'))
                }
            },
            {
                query: GET_NON_WORKING_BY_MONTH_YEAR, variables: {
                    calendarId: parseInt(state._id),
                    month: parseInt(moment(date).format('M')),
                    year: parseInt(moment(date).format('YYYY'))
                }
            },
            { query: GET_COUNT_EVENT_NONWORKINGDAY }
        ]
    })

    const handleOnChange = (e: any) => {
        if (e.target.value === 'ELIMINAR') {
            setactivo(true)
        } else {
            setactivo(false)
        }
    }

    const handleClose = () => {
        cleardeleteNonWorkingDayModal({}, dispatch);
    }

    const handleOnDelete = () => {
        const idDoc = Number(state.idAux)
        deleteCalendars({
            variables: {
                deleteNonWorkingDayId: idDoc
            },
        }).then(() => {
            SuccessfulAlert({ text: "Día inhábil eliminado con éxito" });
        });
        handleClose()
    }

    const { loading, data } = useQuery(GET_NON_WORKING, {
        variables: {
            id: state.idAux,
        }
    });

    if (loading) return null;
    const nonWorkingDay = data?.GET_NON_WORKING;
    const initialValues = () => {
        return {
            mensaje: ""
        }
    }

    return (
        <div>
            <Dialog open={state.deleteNonWorkingDayModal} aria-labelledby="form-dialog-title" maxWidth={"md"} onClose={handleClose}>
                <div className={styles.em_container}>
                    <div className={styles.contenedorCerrarModal}>
                        <div
                            className={styles.cerrarModal}
                            onClick={() => handleClose()}>
                        </div>
                    </div>
                    <div className={styles.contenedorPrincipal}>
                        <div className={styles.iconoEliminar}>
                        </div>
                        <div className={styles.em_titulo}>
                            ¿Confirmas eliminar el d&iacute;a inhábil?
                        </div>
                        {/* <div className={styles.em_mensajePrtincipal}>
                        <span className={styles.tituloDatosUpdate}>{event?.name}</span>
                    </div> */}
                        <div className={styles.em_mensajePrtincipal}>
                            <span >Una vez eliminado no podr&aacute;s recuperar la informaci&oacute;n</span>
                            <br />
                            <span >Escribe ELIMINAR  para confirmar</span>
                        </div>
                        <div>
                            <input
                                className={styles.input}
                                type="text"
                                onChange={(e) => handleOnChange(e)}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.em_contenedorBotones}>
                    <button
                        className={styles.em_botonCancelar}
                        onClick={() => handleClose()}
                    >
                        Cancelar
                    </button>
                    {(activo === true ?
                        <button
                            className={styles.em_botonConfirmarActivo}
                            onClick={() => handleOnDelete()}
                        >
                            <div className={styles.em_iconoConfirmarEliminar}></div>
                            <div>
                                Confirmar
                            </div>
                        </button>
                        :
                        <button className={styles.em_botonConfirmarInactivo}>
                            <div className={styles.em_iconoConfirmarEliminar}></div>
                            <div>
                                Confirmar
                            </div>
                        </button>
                    )}

                </div>
            </Dialog>
        </div>

    )
}




export default DeleteNonWorkingDay